import { createAsyncThunk } from "@reduxjs/toolkit";
import { driver_instore_default_pharmacist } from "../../../networking/urlEndPoints";

import Axios from "../../../networking/interceptor";

export const saveInstoreDefaultPharmacist = createAsyncThunk('saveInstoreDefaultPharmacist', async (requestedData, { rejectWithValue }) => {
	try {
		const uploadData = {
			pharmacy_id: requestedData.pharmacy_id,
			pharmacist_id: requestedData.pharmacist_id
		}

		const response = await Axios.post(driver_instore_default_pharmacist, uploadData)
		const data = response.data
		return data;

	} catch (error) {
		return rejectWithValue(error.response)
	}
})

export const clearInstoreDefaultPharmacist = createAsyncThunk('clearInstoreDefaultPharmacist', async (requestedData, { rejectWithValue }) => {
	try {
		const params = {
			pharmacy_id: requestedData.pharmacy_id
		}

		const response = await Axios.delete(driver_instore_default_pharmacist, { params })
		const data = response.data
		return data;

	} catch (error) {
		return rejectWithValue(error.response)
	}
})
